
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/specifications",
      function () {
        return require("private-next-pages/specifications/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/specifications"])
      });
    }
  